import React from "react";

const Minut = () => {
  return <div></div>;
};

export default Minut;
